
const HIGH_PRIORITY_LABELS = [
  "Forms to Review",
  "Timesheets to Approve",
  "Leave Requests",
  "Contracts Expiring Soon",
  "Expiring Soon",
  "To Submit",            // For contractors
  "To Re-upload",
  "Pending",
  "Rejected"
];

export default function MetricGroupCard({ title, metrics, className }) {
  return (
    <div className={`group-card ${className || ""}`}>
      <div className="group-card-title">{title}</div>
      <div className="group-card-items">
        {metrics.map((metric, index) => {
          const isHighPriority =
            HIGH_PRIORITY_LABELS.includes(metric.label) &&
            (metric.value ?? 0) > 0;

          return (
            <div
              key={index}
              className="group-card-item"
              onClick={metric.onClick}
              style={{ cursor: metric.onClick ? "pointer" : "default" }}
            >
              <span className="item-label">{metric.label}</span>
              <span
                className={`item-value ${isHighPriority ? "high-priority" : ""}`}
                dangerouslySetInnerHTML={{ __html: metric.value ?? 0 }}
              >
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}